import { TransactionHistoryRequest, TransactionHistoryItem } from 'vopay';
import { useState } from 'react';
import vopayApi from '@/services/api.config';
const { api } = vopayApi;

export default function useFetchTransactionHistory({ bearer }: { bearer?: string } = {}) {
  const [transactionHistory, setTransactionHistory] = useState<TransactionHistoryItem[]>([]);

  const fetchTransactionHistory = async (request: TransactionHistoryRequest) => {
    try {
      const res = await api.fetchTransactionHistory(request, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      setTransactionHistory(res.TransactionHistory);

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    transactionHistory,
    fetchTransactionHistory,
  };
}
